<template>
  <div class="container">
    <!-- <p class="titulo-lista-carrito">Total Facturado: ${{ dotsCadaTres(parseFloat(this.totalFacturadoCarrito).toFixed(2).replace(/\.00$/, '')) }}</p>
    <p class="titulo-lista-carrito">Cantidad de productos vendidos: {{ this.cantidadProductosVendidos}}</p> -->
    <button
      class="boton_exportar"
      @click="exportData"
    >
      Exportar a Excel
    </button>
    <table class="tabla-stocks">
      <thead>
        <th>Fecha</th>
        <th>Nombre</th>
        <th>Apellido</th>
        <th>Email</th>
        <th>Monto</th>
        <th>Modalidad</th>
        <th>Sede</th>
      </thead>
      <tbody>
        <Samyoga2025ListaItem
          v-for="inscripto in inscriptos"
          :inscripto="inscripto"
          :key="inscripto.producto_id"
        ></Samyoga2025ListaItem>
      </tbody>
    </table>
  </div>
</template>

<script>
import Samyoga2025ListaItem from '../components/Samyoga2025ListaItem.vue'
import samyogaService from '../services/samyoga'
const XLSX = require('xlsx')
export default {
  name: 'Samyoga2025Lista',
  components: {
    Samyoga2025ListaItem
  },
  data: function () {
    return {
      inscriptos: [],
      archivo: []
    }
  },
  methods: {
    dotsCadaTres (dni) {
      const number = dni.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
      return number
    },
    exportData () {
      console.log(this.pagos)
      const data = this.archivo
      // const data = [{ foo: 'foo' }, { bar: 'bar' }]
      // const fileName = 'Listado_de_Pagos'
      // const exportType = 'csv'
      // exportFromJSON({ data, fileName, exportType })
      // exportFromJSON({ data, exportType })
      const workSheet = XLSX.utils.json_to_sheet(data)
      const workBook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workBook, workSheet, 'Inscripcion_Samyoga')
      XLSX.writeFile(workBook, 'Inscripcion_Samyoga.xlsx')
    },
    exportarExcel (data) {
      this.archivo = []
      for (var j = 0; j < data.length; j++) {
        const obj = {}
        obj.Fecha = data[j].fecha
        obj.Nombre = data[j].persona.nombre
        obj.Apellido = data[j].persona.apellido
        obj.Email = data[j].persona.email
        obj.Monto = data[j].monto || ' - '
        obj.Modalidad = data[j].forma_de_seminario.nombre
        obj.Sede = data[j].sede ? data[j].sede.nombre : ' - '
        this.archivo.push(obj)
      }
    }
  },
  mounted: function () {
    samyogaService
      .traerInscriptosSamyoga()
      .then(respuesta => {
        // this.cargando = false
        this.inscriptos = respuesta
        this.exportarExcel(respuesta)
        console.log('Todos los inscriptos', respuesta)
      })
  }
}
</script>

<style>

</style>
